import React from 'react';
import styled from 'styled-components';

const BaseDivider = styled.div`
  width: 100%;
  border-bottom: 1px solid #abadae;
  margin: 15px 0;
`;

/**
 * Horizontal separator used between form blocks.
 * @returns Styled divider element.
 */
const Divider = () => {
  return (
    <>
      <BaseDivider />
    </>
  );
};

export default Divider;
